import { initializeFirestore, type Firestore } from 'firebase/firestore';
import type { FirebaseApp } from 'firebase/app';

let _db: Firestore | undefined;

export function initDb(app: FirebaseApp, databaseId: string) {
  _db = initializeFirestore(
    app,
    { ignoreUndefinedProperties: true },
    databaseId
  );
}

export function getDb(): Firestore {
  if (!_db) throw new Error('Firestore not initialised');
  return _db;
}
